import { PopupIds } from '../../constants/PopupIds';
import { Localization } from '../../localization/localization';
// @ts-ignore
import * as errorToolTip from '../errorToolTip';
import { TooltipDirection } from '../newErrorToolTip';
import { cancelDeletion } from '../modules/gdpr/cancelDeletion';

const state = {
    accountId: 0,
    deleteAt: 0,
    token: ''
};

let countDown: number;

function handleAccountToBeDeleted(accountId:number, token:string, deleteAt:number) {
    state.accountId = accountId;
    state.token = token;
    state.deleteAt = deleteAt * 1000;
    showPopup();
    updateCounter();
    if (countDown) {
        clearInterval(countDown);
    }
    countDown = window.setInterval(() => {
        updateCounter()
    }, 1000);
}

function updateCounter() {
    const now = new Date().getTime();
    const delta = state.deleteAt - now;
    if (delta < 0) {
        clearInterval(countDown);
        hidePopup();
        return;
    }
    updatePopupText(delta);
}

function updatePopupText(delta:number) {
    const days = Math.floor(delta / (1000 * 60 * 60 * 24));
    const hours = Math.floor((delta % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    let minutes:number|string = Math.ceil((delta % (1000 * 60 * 60)) / (1000 * 60));
    if (minutes < 10) {
        minutes = `0${minutes}`;
    }
    document.getElementById('delete_message').innerHTML = Localization._n(
        'client.accounting.deletion.waiting.message',
        {
            name: `${state.accountId}`,
            time: `${days}d ${hours}:${minutes}`
        }
    );
}

function showPopup() {
    const popup = $(`.popup-window[data-popup-id="${PopupIds.CANCEL_ACCOUNT_DELETION}"]`);
    popup.attr('data-visible', 'true');
}

function hidePopup() {
    const popup = $(`.popup-window[data-popup-id="${PopupIds.CANCEL_ACCOUNT_DELETION}"]`);
    popup.attr('data-visible', 'false');
}

export function initDelayedDeletionPopupHandler() {
    window.app.handleAccountToBeDeleted = handleAccountToBeDeleted;
    const button = $('[data-handler="cancel_account_deletion"]');
    button.on('click', () => {
        cancelDeletion(state.token).then((response) => {
            if ('status' in response && response.status === 1) {
                hidePopup();
            } else {
                errorToolTip(button, TooltipDirection.LEFT, 'Error processing request.');
            }
        });
    });
}
